module.exports = __webpack_public_path__ + "img/avatar1.e6ccafd6.png";